/*
 * nav.js — navegación mínima del sitio (hamburguesa → overlay con 3 anclas).
 * ============================================================================
 * NO es una barra fija (rompería la inmersión del scrollytelling). Es un botón hamburguesa discreto
 * en la esquina que abre un overlay a pantalla completa con las 3 anclas del sitio (Mi trabajo · Sobre
 * mí · Contacto). El botón solo se muestra cuando `body.nav-ready` (lo pone main.js al cerrar el intro).
 *
 * Accesibilidad: aria-expanded en el botón, cierre con Escape (devuelve el foco al botón), clic fuera
 * de la lista cierra. Los enlaces hacen scroll suave: si main.js pasó `scrollTo` (Lenis en modo cinema),
 * se usa; si no, `scrollIntoView` nativo (móvil/reduced).
 */

export function mountSiteNav({ scrollTo } = {}) {
  const nav = document.querySelector('.sitenav');
  if (!nav) return () => {};
  const toggle = nav.querySelector('.sitenav-toggle');
  const menu = nav.querySelector('#sitenav-menu');
  if (!toggle || !menu) return () => {};
  const links = [...menu.querySelectorAll('a')];

  let hideTimer = null;

  function open() {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    menu.hidden = false;
    // siguiente frame para que la transición de opacidad corra desde 0
    requestAnimationFrame(() => nav.classList.add('is-open'));
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Cerrar menú');
    document.addEventListener('keydown', onKey);
  }

  function close() {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Abrir menú');
    document.removeEventListener('keydown', onKey);
    // ocultar del árbol (display:none) tras la transición, para no capturar foco/clics
    hideTimer = setTimeout(() => {
      if (!nav.classList.contains('is-open')) menu.hidden = true;
    }, 340);
  }

  function toggleMenu() { nav.classList.contains('is-open') ? close() : open(); }
  function onKey(e) { if (e.key === 'Escape') { close(); toggle.focus(); } }

  toggle.addEventListener('click', toggleMenu);
  // clic en el fondo del overlay (no en la lista) → cerrar
  menu.addEventListener('click', (e) => { if (e.target === menu) close(); });

  links.forEach((a) => a.addEventListener('click', (e) => {
    const id = (a.getAttribute('href') || '').slice(1);
    const el = id && document.getElementById(id);
    if (!el) return; // deja el comportamiento por defecto si el ancla no existe
    e.preventDefault();
    close();
    // esperar a que el overlay empiece a cerrar para que el scroll no compita con él
    setTimeout(() => {
      if (typeof scrollTo === 'function') scrollTo(el);
      else el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 70);
  }));

  return () => {
    toggle.removeEventListener('click', toggleMenu);
    document.removeEventListener('keydown', onKey);
    if (hideTimer) clearTimeout(hideTimer);
  };
}
